import React from "react";
import { withRouter } from "react-router";
import axios from "axios";
import Base from "./../template/Layout/Base";
import { MenuHandler } from "./MenuHandler";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Services } from "../../repositories/clients/Services";
import { ShowForRole } from "../Global/Permission";

import Authentication from "../../services/Authentication.js";
const auth = new Authentication();

/*=============================================
=            Component For WrapperRoute       =
=============================================*/

const createOffsetValue = (date) => {
  var sign = date.getTimezoneOffset() > 0 ? "-" : "+";
  var offset = Math.abs(date.getTimezoneOffset());
  var hours = Math.floor(offset / 60);
  var minutes = ((offset % 60) / 60) * 10;
  return sign + hours + "." + minutes;
};

function WrapperRoute(props) {
  const MainComponent = props.component;
  let token = auth.getAuthentication("token");
  let RoleId = auth.getAuthentication("RoleId");
  let UserId = auth.getAuthentication("dataUser");
  let UserNameLast = auth.getAuthentication("UserNameLast");
  let UserName = auth.getAuthentication("UserName");
  let Role = auth.getAuthentication("Role");
  let lng = props.lng;

  /* Props Service Desk */

  let ProjectId = 7;
  let Email = auth.getAuthentication("EmailUser");
  let style = {
    titleModule: "legendBasic",
    links: "linkDetail",
    tagSubTitle: "title-custom-value",
    tagValue: "tag-custom-value",
    tagTitle: "titleCardResumen",
  };

  let className = (document.getElementById("body").className = "layout-fixed");
  className = "layout-fixed";
  document.getElementById("body").className = className;

  let moduleLog = {
    UsuarioId: UserId,
    ModuleId: props.name,
    Date: new Date(),
    timezone: createOffsetValue(new Date()),
    SessionId: token,
  };
  axios.post(`${Services.AUDIT.path}modules-log/navigate`, moduleLog);
  window.addEventListener("beforeunload", function (event) {
    let endSession = {
      SessionId: token,
      EndConnection: new Date(),
      timezone: createOffsetValue(new Date()),
      Logout: "0",
    };
    axios.post(`${Services.AUDIT.path}user-logs/logout`, endSession);
  });

  const { history } = props;
  const GetAuthentication = React.useCallback(async () => {
    try {
      await axios.get(`${Services.ADMIN.path}oauth/validate?token=${token}`);
    } catch (error) {
      auth.deleteAuthentication("token");
      auth.deleteAuthentication("dataUser");
      auth.deleteAuthentication("customerSelect");

      let endSession = {
        SessionId: token,
        EndConnection: new Date(),
        timezone: createOffsetValue(new Date()),
        Logout: "1",
      };
      console.log("endSession token invalido", endSession);
      axios.post(`${Services.AUDIT.path}user-logs/logout`, endSession);
      history.push("/");
    }
  }, [token, history]);

  React.useEffect(() => {
    GetAuthentication();
  }, [props.component, GetAuthentication]);

  const FilterCustomer = React.useCallback(
    async (filterCustomer, objectId) => {
      try {
        let data = {
          userId: UserId,
          objectId: objectId,
          moduleAction: filterCustomer,
        };

        let url = `${Services.ADMIN.path}general/verifyCustomerAccess`;
        let res = await axios.post(url, data);

        if (res.data.code !== 200) {
          history.push("/dashboard");
        }
      } catch (error) {
        history.push("/dashboard");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history]
  );

  React.useEffect(() => {
    if (props.filterCustomer && props.filterCustomer !== "") {
      FilterCustomer(props.filterCustomer, props.match.params.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.filterCustomer, FilterCustomer]);

  return (
    <React.Fragment>
      <Base
        Menu={{ Menu: MenuHandler[RoleId] }}
        SideBarConfig={{
          nada: "user nothing",
          UserNameLast: UserNameLast,
          UserName: UserName,
          RoleId: RoleId,
          lng: lng,
          Role: Role,
          module: props.name,
        }}
      >
        {" "}
        {props.moduleAction ? (
          <ShowForRole rol={RoleId} moduleAction={props.moduleAction}>
            <MainComponent
              name={props.name}
              _user={UserId}
              _rolId={RoleId}
              _rolename={Role}
            />{" "}
          </ShowForRole>
        ) : (
          <>
            <MainComponent
              name={props.name}
              _user={UserId}
              _rolId={RoleId}
              _rolename={Role}
              UserName={UserName}
              UserNameLast={UserNameLast}
              ProjectId={ProjectId}
              Email={Email}
              _Role={Role}
              style={style}
              lng={lng}
            />{" "}
          </>
        )}
      </Base>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  lang: state.header.lang,
});
const mapDispatchToProps = () => ({});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(WrapperRoute))
);
